export const checkIfDuplicateExists = (arr: string[]): boolean =>
  new Set(arr.map(url => url.trim())).size !== arr.length
